import TabsContainer from "./TabsContainer";

export default TabsContainer;
